import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import clsx from "clsx";

import Search from "../../features/Search/container";
import { useHasPurchasedProduct } from "../../hooks/usePurchasedProducts";
import { useStyles } from "./css";
import LanguageDialogue from "../Dialog";
import NavBar from "./NavBar";
import LanguageChange from "./NavBar/components/LanguageChange";
import { isIos } from "../../helpers/device-check";
// import SideDrawer from "./SideDrawer/SideDrawer";
import GuideTour from "../../features/GuideTour/container";
import NotificationDrawer from "./NavBar/components/NotificationDrawer";
import { useRouteMatch } from "react-router-dom";
import SideDrawerNew, {
  COLLAPSED_DRAWER_WIDTH,
  EXPANDED_DRAWER_WIDTH,
} from "./SideDrawer/SideDrawerNew";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import CssBaseline from "@material-ui/core/CssBaseline";
import Banner from "./AdBanner";
import NPSFeedback from "../NPSFeedback";
import { UpgradeBannerTop, UpgradeBannerBottom } from "./UpgradeBanner";

const CommonTemplate = (props) => {
  const {
    children,
    upgradeBanner,
    referralInteract,
    handleNotiBadgeClick,
    notiData,
    notiLoading,
    toggleSearch,
    toggleLanguageDialogue,
    patchLanguageChange,
    localeData,
    isLanguageDialogueOpen,
    handleNotificationClick,
    handleViewAll,
    user,
    isPopup,
    handleMarkAllAsRead,
    defaultSelectedOption,
    isPublic,
    handleLightMode,
    history,
    selAccordian,
    isSideDrawerOpen: isSideDrawerOpenProp,
    setSideDrawerOpen: setSideDrawerOpenProp,
  } = props;
  let isIosDevice = isIos();
  const [popperEl, setPopperEl] = React.useState(null);
  const [isBackdropOpen, setIsBackdropOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState("home");
  const [settingsDrawerOpen, setSettingsDrawer] = useState(false);
  const [isSideDrawerOpenLocal, setSideDrawerOpenLocal] = useState(true);
  const [isDrawerPermanent, setDrawerPermanent] = useState(false);

  const isSideDrawerOpen =
    isSideDrawerOpenProp !== undefined
      ? isSideDrawerOpenProp
      : isSideDrawerOpenLocal;
  const setSideDrawerOpen =
    setSideDrawerOpenProp || ((value) => setSideDrawerOpenLocal(value));
  let isLightMode =
    localStorage.getItem("isLightMode") === "true" ? true : false;
  const classes = useStyles({
    backdropOpen: isBackdropOpen,
    drawerOpen: isSideDrawerOpen,
    isIosDevice: isIosDevice,
    isLightMode: isLightMode,
  });
  const bannerProductAlias =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.productAlias
      : undefined;
  const bannerTitle =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.title
      : undefined;
  const bannerDisclaimer =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.disclaimer
      : undefined;
  const bannerDescription =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.description
      : undefined;
  const bannerPageKey =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.pageKey
      : undefined;
  const bannerUpgradeUrl =
    upgradeBanner && typeof upgradeBanner === "object"
      ? upgradeBanner.upgradeUrl
      : undefined;
  const wantsTopBanner =
    upgradeBanner === "top" ||
    (Array.isArray(upgradeBanner) && upgradeBanner.includes("top")) ||
    (upgradeBanner && typeof upgradeBanner === "object" && upgradeBanner.top);
  const wantsBottomBanner =
    upgradeBanner === "bottom" ||
    (Array.isArray(upgradeBanner) && upgradeBanner.includes("bottom")) ||
    (upgradeBanner &&
      typeof upgradeBanner === "object" &&
      upgradeBanner.bottom);

  const bannerHasAccess =
    upgradeBanner &&
    typeof upgradeBanner === "object" &&
    "hasAccess" in upgradeBanner
      ? upgradeBanner.hasAccess
      : undefined;
  const shouldUseLegacyHook =
    bannerHasAccess === undefined && bannerProductAlias;
  const { hasPurchased } = useHasPurchasedProduct(
    shouldUseLegacyHook ? bannerProductAlias : null
  );
  const hasAccess =
    bannerHasAccess !== undefined
      ? bannerHasAccess
      : bannerProductAlias && hasPurchased;
  const showTopBanner = wantsTopBanner && !(bannerProductAlias && hasAccess);
  const showBottomBanner =
    wantsBottomBanner && !(bannerProductAlias && hasAccess);

  const bottomBannerStorageKey = `upgradeBannerBottomDismissed_${
    bannerProductAlias || "default"
  }`;
  const [bottomBannerDismissed, setBottomBannerDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(bottomBannerStorageKey) === "1";
    } catch {
      return false;
    }
  });
  const showBottomBannerEffective = showBottomBanner && !bottomBannerDismissed;

  useEffect(() => {
    try {
      setBottomBannerDismissed(
        sessionStorage.getItem(bottomBannerStorageKey) === "1"
      );
    } catch {}
  }, [bottomBannerStorageKey]);

  const handleBottomBannerClose = () => {
    setBottomBannerDismissed(true);
    try {
      sessionStorage.setItem(bottomBannerStorageKey, "1");
    } catch {}
  };

  let dialogue = null;
  let sideMenuMode = localStorage.getItem("sideMenuMode");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const drawerOffset = isMobile
    ? 0
    : isSideDrawerOpen
    ? EXPANDED_DRAWER_WIDTH
    : COLLAPSED_DRAWER_WIDTH;

  let { url } = useRouteMatch();

  const getActivePath = (textToCompare) => {
    let formattedPath = "";
    if (url.endsWith("/")) {
      formattedPath = url.slice(0, -1);
    } else {
      formattedPath = url;
    }
    const isUrlContainTextCompare = formattedPath.includes(textToCompare);
    if (isUrlContainTextCompare) return true;
    return false;
  };

  useEffect(() => {
    if (defaultSelectedOption) {
      setSelectedOption(defaultSelectedOption);
    }
  }, [defaultSelectedOption]);

  useEffect(() => {
    let loc = history.location.pathname;
    if (loc.includes("feed")) {
      setSideDrawerOpen(false);
      setDrawerPermanent(false);
    } else {
      setDrawerPermanent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location]);

  const handleSearchClick = () => {
    toggleSearch();
  };

  const handlePopperClose = () => {
    setPopperEl(null);
    setIsBackdropOpen(false);
  };

  const handleNotificationsIconClick = (event) => {
    setPopperEl(event.currentTarget);
    setIsBackdropOpen(true);
    handleNotiBadgeClick();
  };

  const handleNotiClick = (noti) => {
    handlePopperClose();
    handleNotificationClick(noti);
  };

  const handleViewAllNotiClick = () => {
    handlePopperClose();
    handleViewAll();
  };

  const handleLightModeClick = (mode) => {
    localStorage.setItem("isLightMode", mode);
    handleLightMode(mode);
  };

  const handleCommunityClick = () => {
    window.open("https://spiking.com/community", "_blank");
  };

  const handleInsidersClick = () => {
    history.push("/insiders");
  };

  const handleReferalClick = () => {
    referralInteract(true);
  };

  const handleNavigateReferral = () => {
    history.push("/settings/referral");
  };

  const handleCryptoClick = () => {
    if (user && user.IsCryptoMembership) {
      history.push("/cryptos");
    } else {
      window.open("https://spiking.com/pricing", "_blank");
    }
  };

  const handleDashboardSelect = (value) => {
    if (value.includes("Stocks")) {
      props.history.push("/dailybread-new");
    } else if (value.includes("Options")) {
      props.history.push("/options/open-interest");
    } else if (value.includes("Cryptos")) {
      props.history.push("/cryptos");
    }
  };

  // const handleGoogleLogoutFailure = () => {
  //   clearStorage();
  //   handleLogout();
  // };

  const manageNotificationSettings = () => {
    handlePopperClose();
    setSettingsDrawer(true);
  };

  const isPopperOpen = Boolean(popperEl);
  const id = isPopperOpen ? "popper-open" : undefined;

  // Props for notifications
  const notificationProps = {
    id,
    handleNotificationsIconClick,
    handleNotiClick,
    handleViewAllNotiClick,
    manageNotificationSettings,
    handleMarkAllNotiAsRead: handleMarkAllAsRead,
    popperEl,
    isPopperOpen,
    isBackdropOpen,
    handlePopperClose,
    notiData,
    notiLoading,
    isPopup,
    user,
  };

  // Props for language
  const languageProps = {
    localeData,
    toggleLanguageDialogue,
  };

  if (isLanguageDialogueOpen) {
    dialogue = (
      <LanguageDialogue
        show={isLanguageDialogueOpen}
        close={toggleLanguageDialogue}
        onLanguageChange={(localeData) => {
          console.log("change");
          patchLanguageChange(localeData);
          toggleLanguageDialogue();
        }}
      />
    );
  }

  return (
    <>
      <div className={classes.root}>
        {/* {user &&
          (user.MembershipText === "Free User" ||
            user.MembershipText.includes("Membership expires")) && <Banner />} */}
        <CssBaseline />
        <NavBar
          user={user}
          referralInteract={referralInteract}
          notificationProps={notificationProps}
          languageProps={languageProps}
          isSideDrawerOpen={isSideDrawerOpen}
          setSideDrawerOpen={() => setSideDrawerOpen(!isSideDrawerOpen)}
          handleSearchClick={handleSearchClick}
          isLightMode={isLightMode}
          handleLightModeClick={handleLightModeClick}
          handleCommunityClick={handleCommunityClick}
          handleReferalClick={handleReferalClick}
          handleNavigateReferral={handleNavigateReferral}
          handleInsidersClick={handleInsidersClick}
          handleCryptoClick={handleCryptoClick}
          handleDashboardSelect={handleDashboardSelect}
          isDrawerPermanent={isDrawerPermanent}
          drawerOffset={drawerOffset}
        />

        {(sideMenuMode === "new" || !sideMenuMode) && (
          // <SideDrawer
          //   isSideDrawerOpen={isSideDrawerOpen}
          //   setSideDrawerOpen={setSideDrawerOpen}
          //   user={user}
          //   selAccordian={selAccordian}
          //   selectedOption={selectedOption}
          //   isDrawerPermanent={isDrawerPermanent}
          // />
          <SideDrawerNew
            isSideDrawerOpen={isSideDrawerOpen}
            setSideDrawerOpen={setSideDrawerOpen}
            user={user}
            isDrawerPermanent={!isMobile}
          />
        )}

        <NotificationDrawer
          open={settingsDrawerOpen}
          handleSettingsClose={() => setSettingsDrawer(false)}
          user={user}
        />

        <main
          className={
            // getActivePath("profile") || getActivePath("courses")
            clsx(
              classes.content,
              {
                [classes.contentShift]: isSideDrawerOpen && isDrawerPermanent,
              },
              "!p-0 !pt-[90px] flex flex-col"
            )
          }
          style={{
            marginLeft: drawerOffset,
            width: `calc(100% - ${drawerOffset}px)`,
            minWidth: 0,
          }}
        >
          <div className={clsx(showBottomBannerEffective && "pb-[140px]")}>
            {showTopBanner ? (
              <UpgradeBannerTop productAlias={bannerProductAlias} />
            ) : null}
            {children}
          </div>
        </main>
        {showBottomBannerEffective ? (
          <UpgradeBannerBottom
            productAlias={bannerProductAlias}
            upgradeUrl={bannerUpgradeUrl}
            title={bannerTitle}
            description={bannerDescription}
            disclaimer={bannerDisclaimer}
            onClose={handleBottomBannerClose}
            drawerOffset={drawerOffset}
            pageKey={bannerPageKey}
          />
        ) : null}
        {dialogue}
        <div className="md:block hidden">
          <NPSFeedback storageKey="layoutNPS" className="z-[1202]" />
        </div>
        <Search />
        <GuideTour />
      </div>
    </>
  );
};

CommonTemplate.propTypes = {
  isSideDrawerOpen: PropTypes.bool,
  setSideDrawerOpen: PropTypes.func,
  upgradeBanner: PropTypes.oneOfType([
    PropTypes.oneOf(["top", "bottom"]),
    PropTypes.arrayOf(PropTypes.oneOf(["top", "bottom"])),
    PropTypes.shape({
      top: PropTypes.bool,
      bottom: PropTypes.bool,
      productAlias: PropTypes.string,
      upgradeUrl: PropTypes.string,
      hasAccess: PropTypes.bool,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      disclaimer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.bool,
      ]),
    }),
  ]),
  handleNotiBadgeClick: PropTypes.func,
  notiData: PropTypes.object,
  notiLoading: PropTypes.bool,
  toggleSearch: PropTypes.func,
  toggleLanguageDialogue: PropTypes.func,
  patchLanguageChange: PropTypes.func,
  localeData: PropTypes.object,
  isLanguageDialogueOpen: PropTypes.bool,
  handleNotificationClick: PropTypes.func,
  user: PropTypes.object,
  handleViewAll: PropTypes.func,
  isPopup: PropTypes.bool,
  handleMarkAllAsRead: PropTypes.func,
  defaultSelectedOption: PropTypes.string,
  isPublic: PropTypes.bool,
  handleSignIn: PropTypes.func,
  testDeviceToken: PropTypes.string,
  handleUpgradeClick: PropTypes.func,
  referralInteract: PropTypes.func,

  handleLightMode: PropTypes.func,
  selAccordian: PropTypes.string,
};

export default withRouter(CommonTemplate);
